import React from 'react';
import { Box, TextField, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import {
  DATA_SOURCE_MODE,
  DATA_SOURCE_REF,
  isDynamic,
} from '../../../flow-core/dataSourceBinding';

/**
 * React half of the data-source binding. The rules (what a valid `${data.x}`
 * reference is, what gets emitted into the Flow JSON) live in
 * `flow-core/dataSourceBinding.js` and are re-exported here so existing imports
 * keep resolving to one implementation.
 */

export {
  DATA_SOURCE_MODE,
  DATA_SOURCE_REF,
  defaultBindingProps,
  isDynamic,
  dataSourceForWhatsApp,
  readLoadedDataSource,
  validateBinding,
} from '../../../flow-core/dataSourceBinding';

/** Static / Dynamic toggle for a component's property editor. */
export const DataSourceModeToggle = ({ properties, onChange }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
      Options source
    </Typography>
    <ToggleButtonGroup
      value={isDynamic(properties) ? 'dynamic' : 'static'}
      exclusive
      size="small"
      onChange={(_, mode) => {
        if (mode) onChange(DATA_SOURCE_MODE, mode);
      }}
    >
      <ToggleButton value="static" sx={{ px: 1.5, py: 0.25, fontSize: '0.7rem' }}>
        Static
      </ToggleButton>
      <ToggleButton value="dynamic" sx={{ px: 1.5, py: 0.25, fontSize: '0.7rem' }}>
        Dynamic (from endpoint)
      </ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

/** The `${data.x}` reference field shown when the data-source mode is dynamic. */
export const DynamicDataSourceField = ({ properties, onChange }) => (
  <TextField
    fullWidth
    size="small"
    label="Data reference"
    value={properties[DATA_SOURCE_REF] || ''}
    onChange={(e) => onChange(DATA_SOURCE_REF, e.target.value)}
    placeholder="${data.available_slots}"
    helperText="Options come from your data-exchange endpoint response, e.g. ${data.available_slots} → [{ id, title }]."
  />
);
